import { render, staticRenderFns } from "./editCommunityPublicityList.vue?vue&type=template&id=2eec8944&scoped=true"
import script from "./editCommunityPublicityList.vue?vue&type=script&lang=js"
export * from "./editCommunityPublicityList.vue?vue&type=script&lang=js"
import style0 from "./editCommunityPublicityList.vue?vue&type=style&index=0&id=2eec8944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec8944",
  null
  
)

export default component.exports